<template>
  <v-layout row flex-wrap mt-2>
    <v-layout column xs6 md12 align-center>
      <v-layout class="mb-2 flex-grow-0">
        <v-icon x-large>fa-android</v-icon>
      </v-layout>
      <android-preview
        :text-application-name="site.name"
        :text-time="'6m'"
        :text-title="title"
        :text-body="message"
        :image="imageUrl"
      />
    </v-layout>
    <v-layout column xs6 md12 align-center>
      <v-layout class="mb-2 flex-grow-0">
        <v-icon x-large>fa-apple</v-icon>
      </v-layout>
      <iphone-preview
        :text-application-name="site.name"
        :text-time="'6m ago'"
        :text-title="title"
        :text-body="message"
        :image="imageUrl"
      />
    </v-layout>
  </v-layout>
</template>

<script>
import { AndroidPreview, IphonePreview } from 'vue-push-notification-preview';
import { mapGetters } from 'vuex';
import './preview.css';
import isObject from 'lodash/isObject';

export default {
  name: 'nx-notification-preview',
  components: {
    AndroidPreview,
    IphonePreview,
  },
  props: {
    titleField: {
      type: String,
      default: 'title',
    },
    messageField: {
      type: String,
      default: 'message',
    },
    imageField: {
      type: String,
      default: 'clipping',
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['site']),
    title() {
      return this.formValue[this.titleField];
    },
    message() {
      return this.formValue[this.messageField];
    },
    imageUrl() {
      const image = this.formValue[this.imageField];
      if (!image) {
        return '';
      }
      if (isObject(image)) {
        return image.clipping.src;
      }
      return image;
    },
  },
};
</script>
